import * as React from 'react'

import { runInAction } from 'mobx'
import { observer } from 'mobx-react'

import BaseNotification from '~/client/src/shared/models/Notification'
import NotificationsStore from '~/client/src/shared/stores/domain/Notifications.store'
import {
  isDeliveryType,
  isPermitType,
  isWorkflowMessageType,
} from '~/client/src/shared/types/NotificationTypes'

import NotificationDetailsDelivery from './components/NotificationDetailsDelivery'
import NotificationDetailsPermit from './components/NotificationDetailsPermit'
import NotificationDetailsViewStore from './NotificationDetailsView.store'

import './NotificationDetailsView.scss'

interface INotificationDetailsStoreProps {
  displayedNotification: BaseNotification
  notificationsStore: NotificationsStore
}
@observer
export default class NotificationDetailsView extends React.Component<INotificationDetailsStoreProps> {
  private readonly store: NotificationDetailsViewStore

  public constructor(props: INotificationDetailsStoreProps) {
    super(props)

    this.store = new NotificationDetailsViewStore()
    this.setNotification(this.props.displayedNotification)
  }

  public UNSAFE_componentWillReceiveProps(
    newProps: INotificationDetailsStoreProps,
  ) {
    if (
      this.props.displayedNotification?.id !==
      newProps.displayedNotification?.id
    ) {
      this.setNotification(newProps.displayedNotification)
    }
  }

  public render() {
    if (!this.props.displayedNotification) {
      return <div />
    }
    const { type, entityId } = this.props.displayedNotification
    if (
      !isDeliveryType(type) &&
      !isPermitType(type) &&
      !isWorkflowMessageType(type)
    ) {
      return <div />
    }

    return (
      <div className="notification-details-content-area full-height overflow-hidden">
        {isDeliveryType(type) ? (
          <NotificationDetailsDelivery
            backClicked={this.backClicked}
            deliveryId={entityId}
            store={this.store}
          />
        ) : (
          <NotificationDetailsPermit
            backClicked={this.backClicked}
            permitId={entityId}
            associatedPermit={this.props.displayedNotification.associatedPermit}
          />
        )}
      </div>
    )
  }

  private backClicked = () => {
    const { notificationsStore } = this.props
    runInAction(() => {
      notificationsStore.markDisplayedAsRead()
      notificationsStore.displayedNotification = null
    })
  }

  private setNotification = (displayedNotification: BaseNotification) => {
    this.store.setNotification(displayedNotification)
  }
}
